import {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/modals/bonus/online';
import {getBonus} from '../../../../../reducers/user/actions';
import Language from '../../../../../language';

export default () => {
    const {bonus_state, currency, button, user} = useSelector(Selector),
          [currentTime, setCurrentTime] = useState(bonus_state.weekly.online.current + (Date.now() - bonus_state.timestamp)),
          dispatch = useDispatch();

    useEffect(() => {
        if(user.type === 'user')
            window.onlineTimeout = setTimeout(() => {
                setCurrentTime(bonus_state.weekly.online.current + (Date.now() - bonus_state.timestamp));
            }, 1e3); 

        return () => clearTimeout(window.onlineTimeout)
    }, [currentTime]);

    const progress = (currentTime / (bonus_state.weekly.online.amount * 60 * 1e3)) * 100;

    return (
        <div className="bonus">
            <div className="text">
                {Language('modals.bonus.weekly.online')}
                <br/>
                ({Math.floor(currentTime / 60e3)}/{bonus_state.weekly.online.amount})
            </div>
            <div className="bonus-progress">
                <div className="progress-border"></div>
                <div className="progress-line" style={{width: `${progress > 100 ? 100 : progress}%`}}></div>
            </div>
            <div className="button-space">
                <div className="claim-button" style={{
                    opacity: (bonus_state.weekly.online.claimed) ? 0.7 : 1
                }} onClick={e => {
                    if(button || bonus_state.weekly.online.claimed)
                        return;

                    dispatch(getBonus({
                        type: 'weekly',
                        bonus: 'online'
                    }));
                }}>
                    {
                        bonus_state.weekly.online.claimed
                        ? Language('modals.bonus.claimed')
                        : Language('modals.bonus.get', {amount: bonus_state.weekly.online.bonus, currency})
                    }
                </div>
            </div>
        </div>
    )
}